module.exports = __webpack_public_path__ + "img/undraw_real_time_collaboration_c62i.10779229.svg";